import { forwardRef, transition } from '@hover/blueprint';
import { iBookmark } from '@hover/icons';
import React from 'react';

import { useHomeownerTranslate, useSaveToProject } from '../../hooks';
import type { AiOrSampleDisplayImage } from '../../types';
import type { TileButtonProps, TileIconButtonProps } from '../TileButton';
import { TileIconButton } from '../TileButton';

export interface SaveTileIconButtonProps
  extends Omit<TileButtonProps, 'label' | 'icon'> {
  image: AiOrSampleDisplayImage;
}

const ToggleTileIconButton = forwardRef<
  TileIconButtonProps & { isToggled: boolean },
  'button'
>(({ isToggled, sx, ...props }, ref) => (
  <TileIconButton
    sx={{
      ...sx,
      '& svg': {
        fill: isToggled ? 'current' : 'transparent',
        ...transition.easing250('fill'),
      },
    }}
    {...props}
    ref={ref}
  />
));

export const SaveTileIconButton = ({
  image,
  ...props
}: SaveTileIconButtonProps) => {
  const t = useHomeownerTranslate();
  const { isSavedToProject, handleSave } = useSaveToProject({
    image,
    // TODO: update this per the projects tracking plan
    location: 'fullscreen',
  });

  if (!image) return null;

  return (
    <ToggleTileIconButton
      aria-label={t('projects.save')}
      icon={iBookmark}
      isToggled={isSavedToProject}
      label={t('projects.save')}
      onClick={handleSave}
      {...props}
    />
  );
};
